// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'ce9d035ec41c0a23d89fe78ab941a13aad8ee2d5';
export const BUILD_NUMBER = '266';
export const BUILD_TIMESTAMP = '2026-10-16T07:58:10.516Z';
